import React from "react";
import { getRequest, postRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";
import ResetIcon from "components/icons/ResetIcon"
import Modal from 'react-modal';

const { DateTime } = require("luxon");

class SovrnMerchantData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            merchants: [],
            show: false,
            merchantsLoading: false,
            merchantId: null,
            MerchantsTable: {
                title: "Affiliate merchants",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'merchantName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getMerchants();
    };

    getMerchants = async () => {
        let url = `/api/Merchant/GetSovrnMerchants`;

        this.setState({ merchantsLoading: true });

        try {
            const merchants = await getRequest(url);

            this.setState({
                merchants,
                merchantsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching merchants:", error);
            this.setState({ merchants: [], merchantsLoading: false });
        }
    };

    handleUpdateApproved = (id) => {
        this.setState({ merchantId: id, show: !this.state.show });
    }

    showModal = (e) => {
        e.preventDefault();
        this.setState({ show: !this.state.show });
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    onRefreshYes = (e) => {
        e.preventDefault();

        this.updateSovrnRockPorchApproved();

        this.setState({ show: false })
    };

    updateSovrnRockPorchApproved = async () => {
        const merchantId = this.state.merchantId;

        let url = `/api/Merchant/UpdateSovrnRockPorchApproved`;

        this.setState({ sovrnUpdating: true });

        try {
            var payload = { merchantId, apmId: this.props.affiliateProgramManager.id }
            var merchant = await postRequest(url, payload);

            // Update the specific merchant in the merchants array
            this.setState((prevState) => ({
                merchants: prevState.merchants.map(m =>
                    m.id === merchantId
                        ? { ...m, rockPorchApproved: !m.rockPorchApproved }
                        : m
                ),
                sovrnUpdating: false,
            }));
        } catch (error) {
            console.error("Error updating RockPorchApproved for merchantId " + merchantId + "." , error);
            this.setState({ sovrnUpdating: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "id",
                label: "Merchant ID",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ?? "-";
                    },
                },
            },
            {
                name: "groupId",
                label: "Group ID",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ?? "-";
                    },
                },
            },
            {
                name: "rockPorchApproved",
                label: "RockPorch Approved",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const merchant = this.state.merchants[tableMeta.rowIndex];
                        const id = merchant.id;
                        return (
                            <div className="d-flex flex-column align-items-center" style={{ gap: "10px" }}>
                                <div className={`commission-status-${value ? "green" : "red"}`}>
                                    <div onClick={(e) => this.handleUpdateApproved(id)}>
                                        <ResetIcon height="12" width="12" pathStroke="#b3b3b3" style={{ position: "relative", left: "50%", transform: "translate(-50%, 4px)" }} />
                                    </div>
                                </div>
                                <p>
                                    {value ? "Yes" : "No" }
                                </p>
                            </div>
                        );
                    },
                },
            },
            {
                name: "name",
                label: "Name",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ?? "-";
                    },
                },
            },
            {
                name: "domain",
                label: "Domain",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ?? "-";
                    },
                },
            },
            {
                name: "description",
                label: "Description",
                options: {
                    filter: true,
                    sort: false,
                    customBodyRender: (value) => {
                        return (
                            <div
                                style={{
                                    maxHeight: "100px",
                                    width: "300px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 5,
                                    WebkitBoxOrient: "vertical",
                                    wordBreak: "break-word",
                                }}
                                title={value}
                            >
                                {value ?? "-"}
                            </div>
                        );
                    },
                },
            },
            {
                name: "terms",
                label: "Terms",
                options: {
                    filter: true,
                    sort: false,
                    customBodyRender: (value) => {
                        return (
                            <div
                                style={{
                                    maxHeight: "100px",
                                    width: "300px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 5,
                                    WebkitBoxOrient: "vertical",
                                    wordBreak: "break-word",
                                }}
                                title={value}
                            >
                                {value ?? "-"}
                            </div>
                        );
                    },
                },
            },
            {
                name: "sovrnPreferred",
                label: "Sovrn Preferred",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ? "✅ Yes" : "❌ No";
                    },
                },
            },
            {
                name: "logoImageUrl",
                label: "Logo",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value) => {
                        return value ? (
                            <img
                                src={value}
                                alt="Merchant Logo"
                                style={{ maxWidth: "150px", maxHeight: "150px" }}
                            />
                        ) : (
                            "-"
                        );
                    },
                },
            },
            {
                name: "category",
                label: "Category",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ?? "-";
                    },
                },
            },
            {
                name: "geo",
                label: "Geo",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ?? "-";
                    },
                },
            },
            {
                name: "averageEpc",
                label: "Average EPC",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value != null ? value.toFixed(4) : "-";
                    },
                },
            },
            {
                name: "averageOrderValue",
                label: "Average Order Value",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value != null ? `$${value.toFixed(2)}` : "-";
                    },
                },
            },
            {
                name: "calculatedCommissionRate",
                label: "Calculated Commission Rate",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value != null ? `${(value * 100).toFixed(4)}%` : "-";
                    },
                },
            },
            {
                name: "maxCommissionRate",
                label: "Max Commission Rate",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value != null ? `${value.toFixed(4)}%` : "-";
                    },
                },
            },
            {
                name: "rates",
                label: "Rates",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value) => {
                        return (
                            <div
                                style={{
                                    maxHeight: "100px",
                                    width: "400px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 5,
                                    WebkitBoxOrient: "vertical",
                                    wordBreak: "break-word",
                                }}
                                title={value}
                            >
                                {value ?? "-"}
                            </div>
                        );
                    },
                },
            },
            {
                name: "cpaDomains",
                label: "CPA Domains",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value) => {
                        return (
                            <div
                                style={{
                                    maxHeight: "100px",
                                    width: "300px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    wordBreak: "break-word",
                                }}
                                title={value}
                            >
                                {value ?? "-"}
                            </div>
                        );
                    },
                },
            },
            {
                name: "calculatedEpc",
                label: "Calculated EPC",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value != null ? value.toFixed(4) : "-";
                    },
                },
            },
            {
                name: "cpcDomains",
                label: "CPC Domains",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value) => {
                        return (
                            <div
                                style={{
                                    maxHeight: "100px",
                                    width: "300px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    wordBreak: "break-word",
                                }}
                                title={value}
                            >
                                {value ?? "-"}
                            </div>
                        );
                    },
                },
            },
        ];


        return (
            <div>
                <Modal isOpen={this.state.show}
                    style={
                        {
                            overlay: {
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: 9998,
                            },
                            content: {
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                border: '1px solid #ccc',
                                background: '#fff',
                                overflow: 'auto',
                                WebkitOverflowScrolling: 'touch',
                                borderRadius: '4px',
                                outline: 'none',
                                padding: '50px',
                                minWidth: '300px',
                                height: '550px',
                                zIndex: 1060,
                            }
                        }
                    }
                    onRequestClose={() => this.setState({ show: false })}
                >

                    <div className="d-flex flex-column justify-content-center h-100">
                        <div className="mx-0 my-0">
                            <h1 style={{ textAlign: "center", display: "block", fontSize: '1.75rem' }}>
                                Are you sure that you want to update the Approved Status for this merchant?
                            </h1>
                            <p style={{ textAlign: 'center', marginTop: "35px", fontWeight: "bold" }}>
                                NOTE: Updated status will may take a few minutes to proprogate through the RockPoch application even after the approval status changes color...
                            </p>
                        </div>

                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <button type="button" className="btn btn-primary mr-2" onClick={(e) => this.onRefreshYes(e, this.state.merchantId)}>Yes</button>
                            <button type="button" className="btn btn-secondary ml-2" onClick={() => this.setState({ show: false })}>No</button>
                        </div>
                    </div>
                </Modal>
                <ThemeProvider theme={this.state.MerchantsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " merchants" ?? "No affiliate selected"}</p>
                            </div>
                        }
                        data={this.state.merchants}
                        columns={columns}
                        options={{
                            ...this.state.MerchantsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.merchantsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default SovrnMerchantData;
